<template>
  <div>
    <div v-if="showCardType" class="form-row">
      <div class="form-group col-md-12">
        <label for="Card Number">{{ $t('message.cardType') }}</label>
        <select v-model="cardType" class="form-control">
          <option value="master" selected>{{ $t('message.masterCard') }}</option>
          <option value="visa">{{ $t('message.visaCard') }}</option>
        </select>
      </div>
    </div>
    <div class="form-row">
      <div class="form-group col-md-12">
        <label for="Card Holder Name">{{ $t('message.cardHolderName') }}</label>
        <input
          v-validate="'required'"
          id="cardHolder"
          v-model="editModel.CardHolder"
          name="Card Holder Name"
          type="text"
          class="form-control"
        />
        <div class="invalid-feedback">{{ OOErrors.first("Card Holder Name") }}</div>
      </div>
      <div class="form-group col-md-6">
        <label for="Card Number">{{ $t('message.cardNumber') }}</label>
        <input
          v-validate="'required|credit_card'"
          id="cardinput"
          v-model="editModel.CardNumber"
          name="Card Number"
          type="text"
          class="form-control"
          placeholder="Card Number"
          v-mask="'#### #### #### ####'"
        />
        <div class="invalid-feedback">{{ OOErrors.first("Card Number") }}</div>
      </div>
      <div class="form-group col-md-4">
        <label for="Expiry Date">{{ $t('message.expiryDate') }}</label>
        <input
          v-validate="{ required: true, regex: /^((0[1-9])|([1-9])|(1[012]))\/((201[19])|(202[0-9]))$/ }"
          id="exInput"
          v-model.trim="editModel.ExpireDate"
          type="text"
          name="Expiry Date"
          class="form-control"
          placeholder="MM/YYYY"
          v-mask="'##/####'"
        />
        <div class="invalid-feedback">{{ OOErrors.first("Expiry Date") }}</div>
      </div>
      <div class="form-group col-md-2">
        <label for="CVV">{{ $t('message.CVV') }}</label>
        <input
          v-validate="{ required: true, regex: /^[0-9]{3,4}$/ }"
          id="CVV"
          v-model="editModel.CVV"
          name="CVV"
          type="text"
          class="form-control"
          placeholder="111"
          v-mask="['###']"
        />
        <div class="invalid-feedback">{{ OOErrors.first("CVV") }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mask } from "vue-the-mask";
import { mapActions } from "vuex";
export default {
  name: "card-component",
  directives: { mask },
  props: {
    editModel: {
      type: Object,
      default: () => {}
    },
    Title: {
      type: String,
      default: () => ""
    },
    showCardType: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      cardType: "master"
    };
  },
  watch: {
    "editModel.CardNumber": function(val) {
      this.$validator.validate("Card Number").then(res => {
        if (res) this.setCardNumber(val);
        else this.clearCardType();
      });
    }
  },
  methods: {
    ...mapActions(["setCardNumber", "clearCardType"]),
    validate() {
      return this.$validator.validateAll();
    }
  }
};
</script>
<style lang="scss" scoped>
.card-vaidation {
  .invalid-feedback {
    display: block;
  }
}
</style>